/**
 * configurator API
 * configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import {CodeNameVo} from './codeNameVo';
import {ContactDTO} from './contactDTO';
import {Remuneration} from './remuneration';

export interface CompanyDto {
    id?: string;
    datastoreVo: CodeNameVo;
    startDate: Date;
    endDate: Date;
    name: string;
    department?: string;
    address1: string;
    address2?: string;
    city: string;
    zipcode: string;
    country: string;
    tva: string;
    vatValue?: number;
    priceDisplayMode?: 'HT' | 'TTC';
    language?: 'fr' | 'en';
    siren: string;
    contacts?: Array<ContactDTO>;
    affiliation: string;
    remunerations?: Array<Remuneration>;
    costs?: CompanyCostConfiguration;
}

export interface CompanyCostConfiguration {
    purchaseCosts?: CompanyCostSet;
    saleCosts?: CompanyCostSet;
    scheduledCosts?: Array<CompanyScheduledCost>;
}

export interface CompanyCostSet {
    contactCosts?: CompanyContactCosts;
    orderCosts?: CompanyOrderCosts;
}

export interface CompanyContactCosts {
    defaultPrice?: number;
    flightPrice?: number;
    hotelPrice?: number;
    carPrice?: number;
    parkingPrice?: number;
}

export interface CompanyOrderCosts {
    flightPrice?: number;
    hotelPrice?: number;
    carPrice?: number;
    parkingPrice?: number;
}

export interface CompanyScheduledCost {
    costType: CompanyScheduledCost.CostTypeEnum;
    dataType: CompanyScheduledCost.DataTypeEnum;
    product: CompanyCostProductEnum;
    price: number;
    effectiveDate: string;
    applied?: boolean;
    appliedAt?: Date;
}

export namespace CompanyScheduledCost {
    export type CostTypeEnum = 'ACQUISITION' | 'SALE';
    export const CostTypeEnum = {
        ACQUISITION: 'ACQUISITION' as CostTypeEnum,
        SALE: 'SALE' as CostTypeEnum
    };

    export type DataTypeEnum = 'ORDERS' | 'CONTACTS';
    export const DataTypeEnum = {
        ORDERS: 'ORDERS' as DataTypeEnum,
        CONTACTS: 'CONTACTS' as DataTypeEnum
    };
}

export enum CompanyCostProductEnum {
    DEFAULT = 'default',
    FLIGHT = 'flight',
    HOTEL = 'hotel',
    CAR = 'car',
    PARKING = 'parking'
}
